import { useQuery } from "@tanstack/react-query";
import { DropsApi } from "@devour/client";
import getConfig from "@/utils/getConfig";

export function useGetDropXTweets(slug?: string) {
    return useQuery({
        queryKey: ["drop-x-tweets", slug],
        queryFn: async () => {
            if (!slug) return null;
            const api = new DropsApi(getConfig());
            return (api as any).getDropsSlugSlugContentXTweets({ slug });
        },
        enabled: Boolean(slug),
        staleTime: 30 * 60 * 1000,
    });
}
